// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Caml_array from "../../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as LoadingVehicleCardCmp from "./LoadingVehicleCardCmp.bs.js";

function LoadingVehicleCards(Props) {
  var loadingPlaceholderConfig = Caml_array.make(6, 1);
  return React.createElement("div", {
              className: "section__container"
            }, React.createElement("span", {
                  className: "title"
                }, "VEHICLE SELECTION"), React.createElement("div", {
                  className: "vehicle-cards"
                }, Belt_Array.mapWithIndex(loadingPlaceholderConfig, (function (index, param) {
                        return React.createElement(LoadingVehicleCardCmp.make, {
                                    key: String(index)
                                  });
                      }))));
}

var make = LoadingVehicleCards;

export {
  make ,
  
}
/* react Not a pure module */
